import {z} from 'zod'

export const AccessTypeCategoryEnum = z.enum([
    'project_management',
    'team_meeting',
    'specialist_visits',
    'treatments',
    'evaluations',
    'observation_and_evaluation' // from SIR
])
export type AccessTypeCategoryEnum = z.infer<typeof AccessTypeCategoryEnum>

export const InPersonAccessEnum = z.enum([
    'evaluation_and_observation',
    'neuromotor_rehabilitation',
    'speech_rehabilitation',
    'psychomotor_rehabilitation',
    'cognitive_neuropsych_rehabilitation',
    'psychological_therapy_parent_training',
    'occupational_therapy',
    'educational_intervention',
    'parent_training'
])

export const NonInPersonAccessEnum = z.enum(['processing', 'untracked', 'counseling', 'law_104_compliance'])

export const SiarEventTypeEnum = z.enum([
    'medical_access',
    'rehabilitation_therapist_access',
    'psychosocial_access',
    'other'
])
export type SiarEventTypeEnum = z.infer<typeof SiarEventTypeEnum>

export const AccessGroupNameEnum = z.enum(['in_person_accesses', 'non_in_person_accesses', 'treatments'])
export type AccessGroupNameEnum = z.infer<typeof AccessGroupNameEnum>

export const AccessTypeKeyName = z.enum([
    'cardiac_holter',
    'cardiology_visit',
    'certification',
    'cognitive_neuropsych_rehab',
    'counseling',
    'cycle_closing_processing',
    'cycle_opening_processing',
    'educational_intervention',
    'educator_evaluation',
    'orl_visit',
    'extension_processing',
    'glo_meeting',
    'initial_project_evaluation',
    'initial_social_service_eval',
    'intermediate_project_evaluation',
    'neurological_specialist_visit',
    'neuromotor_evaluation',
    'neuromotor_rehab',
    'neuropsychiatric_specialist_visit',
    'nutritional_visit',
    'occupational_therapy',
    'occupational_therapy_evaluation',
    'orthopedic_visit',
    'parent_training',
    'pediatric_visit',
    'physiatric_specialist_visit',
    'project_closing_processing',
    'project_opening_processing',
    'project_renewal_processing',
    'psychological_evaluation',
    'psychological_therapy',
    'psychomotor_evaluation',
    'psychomotor_therapy',
    'pulmonology_visit',
    'short_extension_processing',
    'short_team_meeting',
    'social_service_evaluation',
    'speech_evaluation',
    'speech_therapy',
    'team_meeting',
    'update_medical_record',
    'medical_interview',
    'therapy_evaluation',
    // from SIR
    'project_management_and_revision_sir',
    'team_meeting_sir',
    'observation_and_evaluation_sir',
    'observation_and_evaluation_sir_tr',
    'observation_and_evaluation_sir_mrp'
])
export type AccessTypeKeyName = z.infer<typeof AccessTypeKeyName>

export const AccessType = z.object({
    id: z.string(),
    groupName: AccessGroupNameEnum,
    name: z.string(),
    accessType: AccessTypeKeyName,
    siarAccessType: SiarEventTypeEnum,
    category: AccessTypeCategoryEnum,
    inPersonAccess: InPersonAccessEnum.nullable(),
    nonInPersonAccess: NonInPersonAccessEnum.nullable(),
    slot: z.number(),
    medicalRecordReportTypeId: z.string().nullable()
})
export type AccessType = z.infer<typeof AccessType>
